<template>
  <v-dialog
    v-model="dialog"
    max-width="600"
    persistent
    :fullscreen="$vuetify.breakpoint.mobile"
  >
    <v-toolbar max-height="64">
      <v-toolbar-title>
        {{ $t("changePassword") }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="closeDialog" :disabled="loading">
        <v-icon>
          mdi-close
        </v-icon>
      </v-btn>
    </v-toolbar>

    <v-card rounded="0">
      <v-card-text class="pa-6 pt-4">
        <v-form v-model="form.valid" @submit="savePhone">
          <PasswordRules :rules="passwordRules" />

          <v-text-field
            :label="$t('password')"
            v-model="form.password"
            solo-inverted
            clearable
            :type="show.password ? 'text' : 'password'"
            :append-icon="show.password ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="show.password = !show.password"
            :rules="[rules.required]"
            @keydown.space="(event) => event.preventDefault()"
            counter="8"
            maxlength="8"
          ></v-text-field>

          <v-text-field
            :label="$t('confirmPassword')"
            v-model="form.confirmPassword"
            solo-inverted
            clearable
            :type="show.confirmPassword ? 'text' : 'password'"
            :append-icon="show.confirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="show.confirmPassword = !show.confirmPassword"
            :rules="[rules.required]"
            @keydown.space="(event) => event.preventDefault()"
            counter="8"
            maxlength="8"
          ></v-text-field>

          <v-card-actions class="d-flex justify-end px-0">
            <v-btn
              color="primary"
              :disabled="enableSave === false || loading"
              :loading="loading"
              @click="savePhone"
            >
              {{ $t("toSave") }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import PasswordRules from "./PasswordRules";

export default {
  props: {
    dialog: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
    },
  },

  components: { PasswordRules },

  data: (vm) => ({
    form: {
      valid: false,
      password: "",
      confirmPassword: "",
    },
    show: {
      password: false,
      confirmPassword: false,
    },
    rules: {
      required: (v) => !!v || vm.$t("thisFieldIsRequired"),
    },
    passwordRules: {
      oneUppercaseLetter: {
        error: true,
        message: vm.$t("firstPasswordRegistration.rules.oneUppercaseLetter"),
        validate: (v) => /(?=.*?[A-Z])/.test(v),
      },
      oneLowercaseLetter: {
        error: true,
        message: vm.$t("firstPasswordRegistration.rules.oneLowercaseLetter"),
        validate: (v) => /(?=.*?[a-z])/.test(v),
      },
      oneSpecialCharacter: {
        error: true,
        message: vm.$t("firstPasswordRegistration.rules.oneSpecialCharacter"),
        validate: (v) => /(?=.*?[#?!@$%^&*-])/.test(v),
      },
      oneNumber: {
        error: true,
        message: vm.$t("firstPasswordRegistration.rules.oneNumber"),
        validate: (v) => /(?=.*?[0-9])/.test(v),
      },
      eightCharacters: {
        error: true,
        message: vm.$t("firstPasswordRegistration.rules.eightCharacters"),
        validate: (v) => v.length === 8,
      },
      confirmation: {
        error: true,
        message: vm.$t("firstPasswordRegistration.rules.confirmation"),
        validate: () =>
          vm.form.password && vm.form.confirmPassword
            ? vm.form.password === vm.form.confirmPassword
            : false,
      },
    },
  }),

  watch: {
    dialog(val) {
      if (!val) {
        setTimeout(() => {
          this.form.confirmPassword = "";
          this.form.password = "";
        }, 100);
      }
    },
    "form.password"() {
      this.checkPasswordRules();
    },
    "form.confirmPassword"() {
      this.checkPasswordRules();
    },
  },

  computed: {
    enableSave() {
      let allValidRules = true;

      for (const rule in this.passwordRules) {
        if (this.passwordRules[rule].error === true) {
          allValidRules = false;
        }
      }

      return allValidRules && this.form.valid;
    },
  },

  methods: {
    savePhone() {
      if (this.enableSave === false) {
        return;
      }

      this.$emit("doLogin", {
        newPassword: this.form.password,
        type: "changePassword",
      });
    },
    checkPasswordRules() {
      for (const rule in this.passwordRules) {
        this.passwordRules[rule].error =
          this.passwordRules[rule].validate(
            this.form.password ? this.form.password : ""
          ) === false;
      }
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
  },
};
</script>
